import { BookingDownsellPage } from "../booking-downsell-page";
import { useDownsellFlow } from "../../context/use-downsell-flow";
import { DownsellFlowStep } from "../../context/use-downsell-flow/use-downsell-flow.types";
import { DownsellLoading } from "../downsell-loading/downsell-loading";
import { DownsellResult } from "../downsell-result/downsell-result";

const StepComponents = {
  [DownsellFlowStep.CREATE]: BookingDownsellPage,
  [DownsellFlowStep.LOADING]: DownsellLoading,
  [DownsellFlowStep.RESULT]: DownsellResult,
} as const;

export const DownsellFlow = () => {
  const { currentStep } = useDownsellFlow();

  const Component = StepComponents[currentStep as keyof typeof StepComponents];

  if (!Component) {
    return <BookingDownsellPage />;
  }

  return <Component />;
};
